module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-14.67a1efe3.jpg";